"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.build_data = void 0;
exports.build_data = { "build_version": "3.1.15.7", "build_date": "2022-06-28T11:13:23.794Z", "build_branch": "development", "build_commit": "286762216498067f31efa9704e6e1f7d190d4270" };
//# sourceMappingURL=build_data.js.map